import { render, staticRenderFns } from "./recipe-list.vue?vue&type=template&id=be70513a&scoped=true&"
import script from "./recipe-list.vue?vue&type=script&lang=js&"
export * from "./recipe-list.vue?vue&type=script&lang=js&"
import style0 from "./recipe-list.vue?vue&type=style&index=0&id=be70513a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be70513a",
  null
  
)

export default component.exports